import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/compat/database';
import { AccountStatusState } from '@client/utils/shared-constants';
import { EMPTY, Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

@Injectable()
export class AccountStatusService {
	itemsRef: AngularFireList<AccountStatusState> | Observable<never>;

	constructor(private db: AngularFireDatabase, private auth: AngularFireAuth) {
		auth.authState
			.pipe(
				tap(u => {
					this.itemsRef = u ? this.db.list<AccountStatusState>(`/user/${u.uid}/accountStatus`) : EMPTY;
				})
			)
			.subscribe();
	}

	hydrate() {
		return this.auth.user.pipe(
			switchMap(u => (u ? this.db.object<AccountStatusState>(`/user/${u.uid}/accountStatus`).valueChanges() : EMPTY))
		);
	}

	update(status: any) {
		return this.auth.user.pipe(
			take(1),
			switchMap(u => (u ? this.db.object<void>(`/user/${u.uid}/accountStatus`).update(status) : EMPTY))
		);
	}
}
